import './style.scss';

const Platforms = () => {
    return (
        <div className="d-flex justify-content-between align-items-center my-4 my-sm-5 platforms-list px-0 px-sm-3">
            <div className="image-wrapper">
                <img src="./Binance-Logo.wine.svg" className="img-fluid" alt="Binance" />
            </div>
            <div className="image-wrapper">
                <img src="./Coinbase-Logo.wine.svg" className="img-fluid" alt="Coinbase" />
            </div>
            <div className="image-wrapper">
                <img src="./coinigy-inc-logo-vector.svg" className="img-fluid" alt="Coinigy" />
            </div>
            <div className="image-wrapper">
                <img src="./Kraken.svg" className="img-fluid" alt="Kraken" />
            </div>
        </div>
    );
};

export default Platforms;
